import { render, staticRenderFns } from "./graficoCategorias.vue?vue&type=template&id=207d04ce&scoped=true&"
import script from "./graficoCategorias.vue?vue&type=script&lang=js&"
export * from "./graficoCategorias.vue?vue&type=script&lang=js&"
import style0 from "./graficoCategorias.vue?vue&type=style&index=0&id=207d04ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207d04ce",
  null
  
)

export default component.exports